import { buildContentfulHooks } from 'services/ContentfulService/hooks/template'
import { parsePartner, Partner } from 'services/ContentfulService/models/partner/partner'
import { IPartnerFields } from 'generated/types/contentful'
import { SlugConstraint } from '../../constraints'
import { ObjectNotFoundError } from 'services/ContentfulService/errors'

export const [usePartners, getPartners, partnerFetcher] = buildContentfulHooks<Partner, IPartnerFields>(
	'partner',
	parsePartner
)

export const getPartnerBySlug = async (slug: string): Promise<Partner> => {
	const partners = await getPartners({ constraints: [SlugConstraint(slug)], count: 1 })
	if (partners.length === 1) return partners.shift()!
	throw new ObjectNotFoundError('partner')
}
